import { Skeleton } from '@/components/ui/skeleton';
import React from 'react';

const ConversationSkeleton = () => (
	<div style={{ marginBottom: 25 }} className="flex flex-col space-y-3">
		<div
			style={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
			}}
		>
			<Skeleton className="h-4 w-1/3" />
			<Skeleton className="h-4 w-1/4" />
		</div>
		<Skeleton className="h-4 w-1/3" />
		<Skeleton className="h-6 w-full" />
	</div>
);

export default ConversationSkeleton;
